const features = [
  {
    title: '暑期档热播剧场',
    tag: '正在热播',
    desc: '《暗夜追踪》《仙道至尊》《欢乐喜剧人》等热门影视综艺集中上线，暑期追剧指南已更新，每日同步西瓜视频与丝瓜视频最新资源。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20spotlight%20rays%20and%20abstract%20film%20reel%20elements%2C%20elegant%20dark%20background%20with%20soft%20bokeh%20lights%2C%20luxurious%20entertainment%20vibe%2C%20warm%20coral%20and%20amber%20accents%2C%20no%20text%2C%20editorial%20quality%2C%20cinematic%20lighting&width=800&height=500&seq=carousel-1-summer&orientation=landscape',
    tagColor: 'primary',
  },
  {
    title: '经典港片怀旧专区',
    tag: '经典回顾',
    desc: '百部粤语原声高清港片一次收录，从周星驰喜剧到王家卫文艺，重温港片黄金年代的每一帧经典画面。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20Hong%20Kong%20cityscape%20with%20warm%20neon%20light%20reflections%2C%20vintage%20cinema%20atmosphere%2C%20soft%20golden%20and%20coral%20toned%20abstract%20background%2C%20film%20grain%20texture%2C%20romantic%20retro%20mood%2C%20no%20text%2C%20artistic%20composition%2C%20elegant%20lighting&width=800&height=500&seq=carousel-2-hk&orientation=landscape',
    tagColor: 'accent',
  },
  {
    title: '纪录片知识盛宴',
    tag: '高分推荐',
    desc: '《蓝色星球III》《人类宇宙》《地球脉动》等顶级纪录片高清上线，在震撼画面中探索自然与人文的奥秘。',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20abstract%20with%20flowing%20ocean%20waves%20and%20warm%20sunlight%20rays%2C%20soft%20organic%20shapes%20in%20teal%20and%20coral%20tones%2C%20cinematic%20documentary%20atmosphere%2C%20elegant%20ethereal%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality%2C%20harmonious%20color%20palette&width=800&height=500&seq=carousel-3-doc&orientation=landscape',
    tagColor: 'secondary',
  },
  {
    title: '动漫追番日历',
    tag: '每周更新',
    desc: '国漫《仙道至尊》《斗破苍穹》日漫《海贼王》《咒术回战》同步追更，完整追番时间表已整理就绪。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20anime-inspired%20composition%20with%20flowing%20energy%20lines%20and%20warm%20golden%20particles%2C%20soft%20gradient%20background%20in%20coral%20and%20amber%20tones%2C%20vibrant%20atmospheric%20lighting%2C%20no%20text%2C%20artistic%20and%20elegant%2C%20high%20detail%20editorial%20style&width=800&height=500&seq=carousel-4-anime&orientation=landscape',
    tagColor: 'primary',
  },
];

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选热门影视专题，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-background-300/80 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className={`text-xs font-medium px-3 py-1.5 rounded-full ${tagColorMap[item.tagColor]} text-background-50`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-medium text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}